import { render, staticRenderFns } from "./Redirection.vue?vue&type=template&id=6c7f57cd&"
import script from "./Redirection.vue?vue&type=script&lang=js&"
export * from "./Redirection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports